const MODAL_LABELLED_BY = 'modal-title';
const MODAL_DESCRIBED_BY = 'modal-description';

export { MODAL_DESCRIBED_BY, MODAL_LABELLED_BY };
